import {
  RadialBar,
  Tooltip,
  RadialBarChart,
  ResponsiveContainer,
} from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "white",
          padding: 10,
          border: "1px solid rgb(204, 204, 204)",
        }}
      >
        <p style={{ marginBottom: "10px" }}>{`موضوع : ${data.subject}`}</p>{" "}
        <p>{`${data.percentage}%`}</p>
      </div>
    );
  }
  return null;
};

const RadialChartComponent = ({ data }) => {
  //   const style = {
  //     top: "50%",
  //     right: 0,
  //     transform: "translate(0, -50%)",
  //     lineHeight: "24px",
  //   };
  return (
    <ResponsiveContainer width="100%" height="100%">
      <RadialBarChart
        cx="50%"
        cy="50%"
        innerRadius="20%"
        outerRadius="80%"
        barSize={10}
        data={data}
      >
        {/* <CartesianGrid strokeDasharray="0" /> */}
        <Tooltip content={<CustomTooltip />} />
        <RadialBar
          minAngle={15}
          //   label={{ position: "insideStart", fill: "#fff" }}
          background
          clockWise
          dataKey="percentage"
        />
        {/* <Legend
          iconSize={10}
          layout="vertical"
          verticalAlign="middle"
          wrapperStyle={style}
        /> */}
      </RadialBarChart>
    </ResponsiveContainer>
  );
};

export default RadialChartComponent;
